<template>
	<div class="h-100">
		<b-container class="d-flex flex-column h-100">
			<figure class="question-text my-5">
				<h1 class="m-0 font-weight-bold" v-html="question.question"></h1>
			</figure>
			<b-row class="mb-5 d-flex flex-grow-1">
				<b-col>
					<div class="question">
						<b-form-group class="m-0">
							<b-row class="mb-3" v-for="(choice, index) in question.choices" v-bind:key="index">
								<b-col cols="12" >
									<b-form-radio v-model="questionAnswer" :value="index" :disabled="answered"><span v-html="choice"></span></b-form-radio>
									<div v-if="submittedAnswer > -1">
										<div v-if="index == correctAnswer" class="text-primary font-weight-bold lead">
											<svg class="feather lg text-primary mr-2">
												<use xlink:href="../assets/images/feather-sprite.svg#check-circle" />
											</svg>
											Correct!
										</div>
										<div v-else-if="submittedAnswer != correctAnswer && submittedAnswer == index" class="text-danger font-weight-bold lead">
											<svg class="feather lg text-danger mr-2">
												<use xlink:href="../assets/images/feather-sprite.svg#x-circle" />
											</svg>
											Incorrect!
										</div>
									</div>
								</b-col>

								<!-- <b-col cols="auto" class="align-self-center mt-3 mb-3 mt-lg-0 mb-lg-0" v-if="submittedAnswer > -1">
									<div v-if="index == correctAnswer" class="text-primary font-weight-bold lead">
										<svg class="feather lg text-primary mr-2">
											<use xlink:href="../assets/images/feather-sprite.svg#check-circle" />
										</svg>
										Correct!
									</div>
									<div v-else-if="submittedAnswer != correctAnswer && submittedAnswer == index" class="text-danger font-weight-bold lead">
										<svg class="feather lg text-danger mr-2">
											<use xlink:href="../assets/images/feather-sprite.svg#x-circle" />
										</svg>
										Incorrect!
									</div>
								</b-col> -->
							</b-row>
						</b-form-group>
						<b-row class="mb-3" v-if="question">
							<b-col cols="12" lg="12">
								<b-button v-if="isAuthenticated && !answered" class="w-100" variant="primary" @click.prevent="verifyQuestion">Submit Answer</b-button>
								<b-button v-else-if="isAuthenticated && answered" class="w-100" variant="primary" to="/dashboard">Already Answered!<br />
									<div class="small">Click to check your score</div>
								</b-button>
								<b-button v-else class="w-100" variant="primary" to="/sign-up">Sign Up to Play!</b-button>
							</b-col>
						</b-row>
						<b-row class="mb-3" v-else>
							<b-col cols="12" lg="8" class="text-center">
								<b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
							</b-col>
						</b-row>
						<b-row class="mb-3">
							<b-col>
								<div :id="medianet.footer.id"></div>
							</b-col>
						</b-row>
					</div>
				</b-col>
				<b-col cols="12" lg="3" class="mt-4 mt-lg-0">
					<!--<b-img src="https://via.placeholder.com/300x600/2c3040/2c3040" fluid></b-img>-->
					<div :id="medianet.content.id"></div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
export default {
	name: 'QuestionView',
	data() {
		return {
			selected: null,
			question: false,
			questionAnswer: -1,
			submittedAnswer: -1,
			correctAnswer: -1,
			answered: false,
			medianet: {
				load: [],//'footer', 'content'],
				header: {
					id: '343520751',
					size: '840x170'
				},
				footer: {
					id: '531567358',
					size: '825x200'
				},
				content: {
					id: '516841732',
					size: '825x400'
				}
			}
		};
	},
	computed: {
		DailyQuestion () {
			const { DailyQuestion } = this.$FeathersVuex.api;
			return DailyQuestion;
		},
		VerifyQuestion () {
			const { VerifyQuestion } = this.$FeathersVuex.api;
			return VerifyQuestion;
		},
		isAuthenticated () {
			return this.$store.getters['auth/isAuthenticated'];
		},
		qid () {
			return this.$route.params.qid || false;
		}
	},
	methods: {
		async verifyQuestion () {
			const verified = new this.VerifyQuestion;
			verified.id = this.question._id;
			verified.answer = this.questionAnswer;
			const result = await verified.create();
			this.correctAnswer = result.correctAnswer;
			this.submittedAnswer = result.answer;
			this.answered = true;
		},
		loadMedianet () {
			for (let medianetName of this.medianet.load) {
				const ad = this.medianet[medianetName];
				try {
					window._mNDetails.loadTag(ad.id, ad.size, ad.id);
				} catch (err) {
					console.log(err);
				}
			}
		}
	},
	async mounted () {
		if (this.qid) {
			this.question = await this.DailyQuestion.get(this.qid);
		} else {
			this.question = await this.DailyQuestion.find().then(question => { return question.data[0]; });
		}
		if (this.question.answered) {
			this.answered = true;
			this.submittedAnswer = this.questionAnswer = this.question.answered.answer;
			this.correctAnswer = this.question.answered.correctAnswer;
		}
		this.loadMedianet();
	}
}
</script>

<style lang="scss">
	.custom-radio {
		padding-left: 0;
		input[type="radio"] {
			visibility: hidden;
		}
		&:not(:last-of-type) {
			margin-bottom: 1rem;
		}
		.custom-control-label {
			width: 100%;
			cursor: pointer;
			padding: 1.5rem 0;
			&:after,
			&:before {
				left: auto;
				position: absolute;
				top: 50%;
				right: 0;
				transform: translateY(-50%);
			}
		}
	}
</style>
